export const DEFAULT_IMAGE_POSITION = { x: 50, y: 25, scale: 1 };

function clamp(value, min, max, fallback) {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(max, Math.max(min, n));
}

export function normalizeImagePosition(pos) {
  return {
    x: clamp(pos?.x, 0, 100, DEFAULT_IMAGE_POSITION.x),
    y: clamp(pos?.y, 0, 100, DEFAULT_IMAGE_POSITION.y),
    scale: clamp(pos?.scale, 1, 3, DEFAULT_IMAGE_POSITION.scale),
  };
}

export function cardImageStyle(pos) {
  const { x, y, scale } = normalizeImagePosition(pos);
  return {
    objectPosition: `${x}% ${y}%`,
    transform: `scale(${scale})`,
    transformOrigin: `${x}% ${y}%`,
  };
}
